import { BaseObj } from '@/objects/BaseObj';
import { useBaseObjEntityStateHandler } from '@/objects/entitystatehandler/entitystatehandler';
import { isRef, ref, unref } from 'vue';
import type { EntityState } from './../enums/EntityState';
import { formatDateIso } from '@/utilities/dateutils';

export class BibAssignPreview extends BaseObj {
    public Blocked: boolean;
    public __blocked: boolean;

    public CategoryID: number | null;
    public __categoryid: number | null;

    public ContestantID: number | null;
    public __contestantid: number | null;

    public GroupID: number | null;
    public __groupid: number | null;

    public Row_num: number;
    public __row_num: number;

    public Seeding1: string | null;
    public __seeding1: string | null;

    public Seeding2: string | null;
    public __seeding2: string | null;

    public Seeding3: string | null;
    public __seeding3: string | null;

    public Seeding4: string | null;
    public __seeding4: string | null;

    public Seeding5: string | null;
    public __seeding5: string | null;

    public Seeding6: string | null;
    public __seeding6: string | null;

    public Seeding7: string | null;
    public __seeding7: string | null;

    public Seeding8: string | null;
    public __seeding8: string | null;

    public Seeding9: string | null;
    public __seeding9: string | null;

    public Sort: number;
    public __sort: number;

    public SourceName: string;
    public __sourcename: string;

    public StartTime: Date | null;
    public __starttime: Date | null;

    public __entityStateHandler;
    public __selfEntityState: EntityState;
    public __entityState: any;
    public get EntityState(): EntityState {
        return unref(this.__entityState);
    }
    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        Blocked?: boolean;
        CategoryID?: number | null;
        ContestantID?: number | null;
        EntityState?: EntityState;
        GroupID?: number | null;
        Row_num?: number;
        Seeding1?: string | null;
        Seeding2?: string | null;
        Seeding3?: string | null;
        Seeding4?: string | null;
        Seeding5?: string | null;
        Seeding6?: string | null;
        Seeding7?: string | null;
        Seeding8?: string | null;
        Seeding9?: string | null;
        Sort?: number;
        SourceName?: string | null;
        StartTime?: Date | null;
    }) {
        super();
        this.__entityState = ref(values.EntityState ?? 'Unchanged');
        this.__selfEntityState = values.EntityState ?? 'Unchanged';
        this.__entityStateHandler = useBaseObjEntityStateHandler<BibAssignPreview>(unref(this.__entityState), (states) => {
            if (isRef(this.__entityState)) {
                this.__entityState.value = states.EntityStateWithChildrenConsidered;
            } else {
                console.warn('BibAssignPreview tried to set entitystate, but entitystate is not a ref! This should never happen');
            }
            this.__selfEntityState = states.SelfEntityState;
        });
        this.Blocked = values.Blocked ?? false;
        this.__blocked = values.Blocked ?? false;
        Object.defineProperty(this, 'Blocked', {
            get(): boolean {
                return this.__blocked;
            },
            set(value: boolean) {
                this.__entityStateHandler.propertyChanged('Blocked', this.__blocked, value);
                this.__blocked = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.CategoryID = values.CategoryID ?? null;
        this.__categoryid = values.CategoryID ?? null;
        Object.defineProperty(this, 'CategoryID', {
            get(): number | null {
                return this.__categoryid;
            },
            set(value: number | null) {
                this.__entityStateHandler.propertyChanged('CategoryID', this.__categoryid, value);
                this.__categoryid = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.ContestantID = values.ContestantID ?? null;
        this.__contestantid = values.ContestantID ?? null;
        Object.defineProperty(this, 'ContestantID', {
            get(): number | null {
                return this.__contestantid;
            },
            set(value: number | null) {
                this.__entityStateHandler.propertyChanged('ContestantID', this.__contestantid, value);
                this.__contestantid = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.GroupID = values.GroupID ?? null;
        this.__groupid = values.GroupID ?? null;
        Object.defineProperty(this, 'GroupID', {
            get(): number | null {
                return this.__groupid;
            },
            set(value: number | null) {
                this.__entityStateHandler.propertyChanged('GroupID', this.__groupid, value);
                this.__groupid = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Row_num = values.Row_num ?? 0;
        this.__row_num = values.Row_num ?? 0;
        Object.defineProperty(this, 'Row_num', {
            get(): number {
                return this.__row_num;
            },
            set(value: number) {
                this.__entityStateHandler.propertyChanged('Row_num', this.__row_num, value);
                this.__row_num = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Seeding1 = values.Seeding1 ?? null;
        this.__seeding1 = values.Seeding1 ?? null;
        Object.defineProperty(this, 'Seeding1', {
            get(): string | null {
                return this.__seeding1;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Seeding1', this.__seeding1, value);
                this.__seeding1 = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Seeding2 = values.Seeding2 ?? null;
        this.__seeding2 = values.Seeding2 ?? null;
        Object.defineProperty(this, 'Seeding2', {
            get(): string | null {
                return this.__seeding2;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Seeding2', this.__seeding2, value);
                this.__seeding2 = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Seeding3 = values.Seeding3 ?? null;
        this.__seeding3 = values.Seeding3 ?? null;
        Object.defineProperty(this, 'Seeding3', {
            get(): string | null {
                return this.__seeding3;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Seeding3', this.__seeding3, value);
                this.__seeding3 = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Seeding4 = values.Seeding4 ?? null;
        this.__seeding4 = values.Seeding4 ?? null;
        Object.defineProperty(this, 'Seeding4', {
            get(): string | null {
                return this.__seeding4;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Seeding4', this.__seeding4, value);
                this.__seeding4 = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Seeding5 = values.Seeding5 ?? null;
        this.__seeding5 = values.Seeding5 ?? null;
        Object.defineProperty(this, 'Seeding5', {
            get(): string | null {
                return this.__seeding5;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Seeding5', this.__seeding5, value);
                this.__seeding5 = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Seeding6 = values.Seeding6 ?? null;
        this.__seeding6 = values.Seeding6 ?? null;
        Object.defineProperty(this, 'Seeding6', {
            get(): string | null {
                return this.__seeding6;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Seeding6', this.__seeding6, value);
                this.__seeding6 = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Seeding7 = values.Seeding7 ?? null;
        this.__seeding7 = values.Seeding7 ?? null;
        Object.defineProperty(this, 'Seeding7', {
            get(): string | null {
                return this.__seeding7;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Seeding7', this.__seeding7, value);
                this.__seeding7 = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Seeding8 = values.Seeding8 ?? null;
        this.__seeding8 = values.Seeding8 ?? null;
        Object.defineProperty(this, 'Seeding8', {
            get(): string | null {
                return this.__seeding8;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Seeding8', this.__seeding8, value);
                this.__seeding8 = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Seeding9 = values.Seeding9 ?? null;
        this.__seeding9 = values.Seeding9 ?? null;
        Object.defineProperty(this, 'Seeding9', {
            get(): string | null {
                return this.__seeding9;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Seeding9', this.__seeding9, value);
                this.__seeding9 = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Sort = values.Sort ?? 0;
        this.__sort = values.Sort ?? 0;
        Object.defineProperty(this, 'Sort', {
            get(): number {
                return this.__sort;
            },
            set(value: number) {
                this.__entityStateHandler.propertyChanged('Sort', this.__sort, value);
                this.__sort = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.SourceName = values.SourceName ?? '';
        this.__sourcename = values.SourceName ?? '';
        Object.defineProperty(this, 'SourceName', {
            get(): string {
                return this.__sourcename;
            },
            set(value: string) {
                this.__entityStateHandler.propertyChanged('SourceName', this.__sourcename, value);
                this.__sourcename = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.StartTime = values.StartTime ?? null;
        this.__starttime = values.StartTime ?? null;
        Object.defineProperty(this, 'StartTime', {
            get(): Date | null {
                return this.__starttime;
            },
            set(value: Date | null) {
                this.__entityStateHandler.propertyChanged('StartTime', this.__starttime, value);
                this.__starttime = value;
            },
            enumerable: true,
            configurable: true,
        });
    }

    public _setNotifyParentOfModificationCallback(callback: () => void) {
        this.__entityStateHandler.setNotifyParentOfModificationCallback(callback);
    }

    public serialize(): string {
        return (
            '{' +
            `"Blocked": ${JSON.stringify(this.Blocked)}` +
            ',' +
            `"CategoryID": ${JSON.stringify(this.CategoryID)}` +
            ',' +
            `"ContestantID": ${JSON.stringify(this.ContestantID)}` +
            ',' +
            `"EntityState": ${unref(this.__selfEntityState) == 'Unchanged' ? 0 : unref(this.__selfEntityState) == 'Deleted' ? 1 : unref(this.__selfEntityState) == 'Modified' ? 2 : unref(this.__selfEntityState) == 'Added' ? 3 : 0}` +
            ',' +
            `"GroupID": ${JSON.stringify(this.GroupID)}` +
            ',' +
            `"Row_num": ${JSON.stringify(this.Row_num)}` +
            ',' +
            `"Seeding1": ${JSON.stringify(this.Seeding1)}` +
            ',' +
            `"Seeding2": ${JSON.stringify(this.Seeding2)}` +
            ',' +
            `"Seeding3": ${JSON.stringify(this.Seeding3)}` +
            ',' +
            `"Seeding4": ${JSON.stringify(this.Seeding4)}` +
            ',' +
            `"Seeding5": ${JSON.stringify(this.Seeding5)}` +
            ',' +
            `"Seeding6": ${JSON.stringify(this.Seeding6)}` +
            ',' +
            `"Seeding7": ${JSON.stringify(this.Seeding7)}` +
            ',' +
            `"Seeding8": ${JSON.stringify(this.Seeding8)}` +
            ',' +
            `"Seeding9": ${JSON.stringify(this.Seeding9)}` +
            ',' +
            `"Sort": ${JSON.stringify(this.Sort)}` +
            ',' +
            `"SourceName": ${JSON.stringify(this.SourceName)}` +
            ',' +
            `"StartTime": ${this.StartTime ? '"' + formatDateIso(this.StartTime) + '"' : null}` +
            ',' +
            `"ChangedColumns": ${unref(this.__selfEntityState) !== 'Modified' ? 'null' : JSON.stringify(this.__entityStateHandler.getChangedPropertiesArray())}` +
            '}'
        );
    }

    /**
     * Sets the entity state to Deleted
     */
    public Delete() {
        if (this.__selfEntityState === 'Added') {
            throw new Error('Cannot delete an object that is in Added state. It has not been saved yet.');
        }
        this.__selfEntityState = 'Deleted';
        this.__entityStateHandler.entityStateChanged(this.__selfEntityState);
    }

    /**
     * Undeletes the object by setting resetting the EntityState
     *
     * If the object has modifications, the new state will be 'Modified', otherwise 'Unchanged'
     */
    public DeleteUndo() {
        this.__selfEntityState = 'Unchanged';
        this.__entityStateHandler.entityStateChanged(this.__selfEntityState);
    }

    /**
                     * Sets the entity state to Added
                     *
                     
                     * 
                     * Note: This does not do anything with the children, so use with caution
                     * 
                     * The use case of this is to make copies of existing objects as new objects without having to fill every field.
                     */
    public SetEntityStateAsAddedAndResetId() {
        if (this.EntityState !== 'Unchanged') {
            throw new Error('Changing a modified object to Added is not supported.');
        }
        this.__selfEntityState = 'Added';

        this.__entityStateHandler.entityStateChanged(this.__selfEntityState);
    }

    /**
     * Creates an instance of BibAssignPreview from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Blocked?: boolean;
        CategoryID?: number | null;
        ContestantID?: number | null;
        GroupID?: number | null;
        Row_num?: number;
        Seeding1?: string | null;
        Seeding2?: string | null;
        Seeding3?: string | null;
        Seeding4?: string | null;
        Seeding5?: string | null;
        Seeding6?: string | null;
        Seeding7?: string | null;
        Seeding8?: string | null;
        Seeding9?: string | null;
        Sort?: number;
        SourceName?: string | null;
        StartTime?: Date | null;
        EntityState?: 'Added' | 'Unchanged';
    }): BibAssignPreview {
        return new BibAssignPreview(values);
    }

    public static _FromServerJson(json: any): BibAssignPreview {
        return new BibAssignPreview({
            Blocked: json.Blocked,
            CategoryID: json.CategoryID ?? null,
            ContestantID: json.ContestantID ?? null,
            GroupID: json.GroupID ?? null,
            Row_num: json.Row_num,
            Seeding1: json.Seeding1 ?? '',
            Seeding2: json.Seeding2 ?? '',
            Seeding3: json.Seeding3 ?? '',
            Seeding4: json.Seeding4 ?? '',
            Seeding5: json.Seeding5 ?? '',
            Seeding6: json.Seeding6 ?? '',
            Seeding7: json.Seeding7 ?? '',
            Seeding8: json.Seeding8 ?? '',
            Seeding9: json.Seeding9 ?? '',
            Sort: json.Sort,
            SourceName: json.SourceName ?? '',
            StartTime: json.StartTime ? (json.StartTime instanceof Date ? json.StartTime : new Date(json.StartTime)) : null,
            EntityState: 'Unchanged',
        });
    }

    /**
     * Creates an instance of BibAssignPreview from another instance of BibAssignPreview.
     * @param other The BibAssignPreview you want to clone
     * @returns A cloned BibAssignPreview
     */
    public static FromOther(other: BibAssignPreview): BibAssignPreview {
        if (other.EntityState !== 'Unchanged') {
            throw new Error('Cloning an object with EntityState other than Unchanged is not supported');
        }
        return BibAssignPreview._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return BibAssignPreview.FromOther(this);
    }

    /**
     * IsPropertyChanged.
     */
    public IsPropertyChanged(
        ...props: (
            | 'Blocked'
            | 'CategoryID'
            | 'ContestantID'
            | 'GroupID'
            | 'Row_num'
            | 'Seeding1'
            | 'Seeding2'
            | 'Seeding3'
            | 'Seeding4'
            | 'Seeding5'
            | 'Seeding6'
            | 'Seeding7'
            | 'Seeding8'
            | 'Seeding9'
            | 'Sort'
            | 'SourceName'
            | 'StartTime'
        )[]
    ) {
        return this.__entityStateHandler.isPropertyChanged(...props);
    }
    static NAME_OF_CLASS = 'BibAssignPreview';
}
